/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const weightChange = useStore((state) => state.weightChange);
  const setWeightChange = useStore((state) => state.setWeightChange);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.weightChange.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={weightChange}
          onChange={(value) => {
            setWeightChange(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'weight-change',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'gainFastLoseSlow'}>
            <span>⚖️</span> {t('onboarding.weightChange.options.gainFastLoseSlow')}
          </Option>
          <Option value={'gainLoseEasily'}>
            <span>🔁</span> {t('onboarding.weightChange.options.gainLoseEasily')}
          </Option>
          <Option value={'struggleToGain'}>
            <span>🦴</span> {t('onboarding.weightChange.options.struggleToGain')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
